import Input from 'antd/lib/input';
import 'antd/lib/input/style/index.css';

export default Input;
